export class PagerService {
    private static readonly DEFAULT_PAGE_SIZE = 10;
    private static readonly VISIBLE_PAGE_WINDOW = 10;
    private static readonly MID_PAGE_THRESHOLD = 6;
    private static readonly END_PAGE_OFFSET = 4;
    private static readonly START_PAGE_OFFSET = 5;

    getPager(totalItems: number, currentPage: number = 1, pageSize: number = PagerService.DEFAULT_PAGE_SIZE) {
        // calculate total pages
      //  console.info(totalItems+"===="+currentPage+"====="+pageSize)
        let totalPages = Math.ceil(totalItems / pageSize);

        // ensure current page isn't out of range
        if (currentPage < 1) { 
            currentPage = 1; 
        } else if (currentPage > totalPages) { 
            currentPage = totalPages; 
        }
        
        let startPage: number, endPage: number;
        if (totalPages <= PagerService.VISIBLE_PAGE_WINDOW) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
           // console.info("test4===>", totalPages);
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= PagerService.MID_PAGE_THRESHOLD) {
                startPage = 1;
                endPage = PagerService.VISIBLE_PAGE_WINDOW;
              //  console.info("test1");
            } else if (currentPage + PagerService.END_PAGE_OFFSET >= totalPages) {
                startPage = totalPages - (PagerService.VISIBLE_PAGE_WINDOW - 1);
                endPage = totalPages;
               // console.info("test2");
            } else {
                startPage = currentPage - PagerService.START_PAGE_OFFSET;
                endPage = currentPage + PagerService.END_PAGE_OFFSET;
              //  console.info("test3");
            }
        }

        // calculate start and end item indexes
        let startIndex = (currentPage - 1) * pageSize;
        let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }
}